import { cssVar } from "@chakra-ui/theme-tools";
import { borderRadiusMd, spacing1x, spacing4x } from "@airhelp/design-tokens";
const $arrowShadowColor = cssVar("popper-arrow-shadow-color");
const baseStylePopper = {
    zIndex: 10,
};
const baseStyleContent = {
    [$arrowShadowColor.variable]: "none",
    backgroundColor: "grayscale.100",
    color: "greyscale.700",
    boxShadow: "md",
    borderColor: "transparent",
    padding: spacing4x,
    borderRadius: borderRadiusMd,
    fontSize: "sm",
    fontWeight: "normal",
    lineHeight: "lineHeightBase",
    _focus: {
        outline: "none",
        boxShadow: "md",
    },
};
const baseStyleHeader = {
    fontWeight: "medium",
    marginBottom: spacing1x,
    padding: "unset",
    border: "none",
};
const baseStyleBody = {
    padding: "unset",
};
const baseStyle = {
    popper: baseStylePopper,
    content: baseStyleContent,
    header: baseStyleHeader,
    body: baseStyleBody,
    arrow: {},
};
const Popover = {
    baseStyle,
};
export default Popover;
